import './App.css';
import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import AdminMap from './pages/AdminMap';
import PlayerCreateTeam from './pages/PlayerCreateTeam';
import PlayerMap from './pages/PlayerMap';

import { onAuthChange, listenTeam } from './firebase';
import Navbar from './components/Navbar';
import LocationWatcher from './components/LocationWatcher';
import PlayerTeam from './pages/PlayerTeam';
import Settings from './pages/Settings';

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  // UID that is allowed to see the Admin link and route. Read from env var REACT_APP_ADMIN_UID.
  // Keep the previous UID as a fallback so the app doesn't break if env is not present.
  const ADMIN_UID = process.env.REACT_APP_ADMIN_UID || 'yUtDbDw9gebb0y6nm0M8DSHCsla2';

  useEffect(() => {
    const unsub = onAuthChange((user) => {
      setCurrentUser(user);
    });
    return unsub;
  }, []);

  function RequireAdmin({ children }) {
    if (!currentUser) return <Navigate to="/" replace />;
    if (currentUser.uid !== ADMIN_UID) return <Navigate to="/" replace />;
    return children;
  }

  function RequirePlayerTeam({ children }) {
  // Must be signed in and a member of the team specified in the ?teamId= query param
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const paramTeamId = params.get('teamId');
  const teamId = paramTeamId || (typeof window !== 'undefined' ? localStorage.getItem('teamId') : null);
    const [team, setTeam] = useState(null);

    useEffect(() => {
      if (!teamId) return;
      const unsub = listenTeam(teamId, setTeam);
      return () => unsub && unsub();
    }, [teamId]);

    if (!currentUser) return <Navigate to="/player" replace />;
    if (!teamId) return <Navigate to="/player" replace />;
    if (team === null) return <div className="container py-4">Loading…</div>;
    // team.members is a map keyed by uid
    if (!team.members || !team.members[currentUser.uid]) return <Navigate to="/player" replace />;
    return children;
  }

  return (
    <BrowserRouter>
      <div className="App">
  <Navbar currentUser={currentUser} adminUid={ADMIN_UID} />
  <LocationWatcher />
        <main style={{padding:12}}>
          <Routes>
            <Route path="/" element={currentUser ? <Navigate to="/player/map" replace /> : <PlayerCreateTeam/>} />
            <Route path="/player" element={currentUser ? <Navigate to="/player/map" replace /> : <PlayerCreateTeam/>} />
            <Route path="/player/map" element={<RequirePlayerTeam><PlayerMap/></RequirePlayerTeam>} />
            <Route path="/player/team" element={<RequirePlayerTeam><PlayerTeam/></RequirePlayerTeam>} />
            {currentUser && currentUser.uid === ADMIN_UID && (
              <>
                <Route path="/admin" element={<RequireAdmin><AdminDashboard/></RequireAdmin>} />
                <Route path="/admin/map" element={<RequireAdmin><AdminMap/></RequireAdmin>} />
              </>
            )}
            <Route path="/admin/login" element={<AdminLogin/>} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
